import React from 'react';
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import './NeedHelp.css';
import need from '../../../images/need-girl-homepage.png';



const NeedHelp = () => {
  return (
    <>
      <div className="need-help"
       style={{ '--background-image': `url(${"https://blueberrywebsites.azureedge.net/bbt/images/RectangleFooter.png"})` }}
      >
        <div className="container height">
            <div className="">
                <div className="row height">
                    <div className="col-md-6 col-6 girl-img">
                        <LazyLoadImage
            effect="blur"
 src={need} alt=""  loading="lazy" />
                    </div>
                    <div className="col-md-6 col-6 text-white d-flex flex-column justify-content-center mt-lg-2 height">
                        <div className="text ms-md-5 ps-md-5">
                            <h1 className="mt-xxl-3 mb-0  mt-md-0 headings need-heading">Need Help ?</h1>
                            <p className="mt-lg-3 mt-2 watever-fs grotesk-headings">Wherever you are, we are available!
                            </p>
                        </div>
                        <div className="carouselCaption ms-md-5 ps-md-5">
                            <a href="/contact">
                                <button className="btn bg-transparent text-white mt-lg-3 grotesk-headings fw-bold">CONTACT US</button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </>
  )
}

export default NeedHelp